<template>
  <div class='orderInfo'>
    <!-- 支付信息 -->
    <div>
      <p>
        <span style="font-weight:700">订单号：&nbsp;</span>
        <span>{{order.onceInfo.order_number}} &nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span style="font-weight:700">订单金额：&nbsp;</span>
        <span>{{order.onceInfo.total_fee / 100}} 元</span>
      </p>
      <p>
        <span style="font-weight:700">订单内容: &nbsp;</span>
        <span>{{order.onceInfo.description}}</span>
      </p>
    </div>
    <!-- 未支付时 -->
    <el-row :gutter="30">
      <el-col :span="9">
        <div>
          <span style="font-weight:700">微信充值：</span>
          <span>充值50元，送10元。充值后，请通过余额进行支付。</span>
        </div>
        <qrcode :value="order.rechargeInfo.paymenturl" :options="{ width: 120 }"> </qrcode>
      </el-col>
      <el-col :span="8">
        <div>
          <span style="font-weight:700">余额支付：</span>
          <span>利用账号余额支付本次费用{{order.onceInfo.total_fee / 100}}&nbsp;元</span>
        </div>
        <div>
          <button class="button" @click="consumptionByAccount()" :disable="paied">
            余额支付
          </button>
        </div>
      </el-col>
      <el-col :span="7">
        <div>
          <span style="font-weight:700">微信支付：</span>
          <span>通过微信支付直接支付本次费用{{order.onceInfo.total_fee / 100}}&nbsp;元</span>
        </div>
        <qrcode :value="order.onceInfo.paymenturl" :options="{ width: 120 }"></qrcode>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import Bus from "@/misc/bus.js";
  export default {
    data() {
      return {
        // 是否已支付
        paied: false,
      };
    },
    computed: {
      users() {
        return this.$store.state.users;
      },
      order() {
        return this.$store.state.order;
      }
    },
    mounted() {
      Bus.$on("paied", e => {
        this.paied = e;
      })
    },
    methods: {
      // 余额支付
      consumptionByAccount() {
        if (this.users.userInfo.authenticated) {
          if (this.order.onceInfo.code == null || this.order.onceInfo.code == '') {
            alert("您没有需要支付的内容")
          } else {
            if (this.paied == true) {
              alert("请勿多次支付")
            } else {
              var params = {
                code: this.order.onceInfo.code,
                total_fee: this.order.onceInfo.total_fee,
                attach: this.order.onceInfo.attach,
                category: this.order.onceInfo.category
              }
              this.$store.dispatch("order/consumptionByAccount", params);
            }
            this.paied = true
          }
        } else {
          alert("使用余额支付，请先登录")
        }
      }
    },
  };
</script>

<style>
  .orderInfo {
    margin-top: 0.1rem;
    padding-bottom: 0.1rem;
    text-align: left
  }


  .orderInfo .button {
    /* background-color: #aa0000 !important; */
    border: solid 0.01rem #aa0000;
    border-radius: 40px;
    margin: 0.2rem;
    color: black;
    outline: none;
    text-align: center;
    text-decoration: none;
    letter-spacing: 0.01rem;
    height: 80px;
    width: 80px;
  }

  .orderInfo .button:hover {
    cursor: pointer;
    background-color: #aa0000 !important;
    color: white !important
  }
</style>